import SimpleDate from 'app/common/classes/simple-date'
import toFixedValue from 'app/common/lib/toFixedValue'
import { EncashmentsRowItemType, ReportEncashmentsData } from 'app/dataTypes/reports/data'

import { converRowEncashments, converRowSummary, convertStatuses } from './convertResults'
import { ApiRowEncashment, ApiRowSummary, ApiStatusesType, dateFormat } from './types'

type ApiRowItemType = {
  summary: ApiRowSummary
  encashments: Array<ApiRowEncashment>
}

export type ApiResultEncashments = {
  date: string
  rows: Array<ApiRowItemType> // набор строк по каждой точке продаж
  summary: {
    // сводные данные
    balance_at_the_beginning: number
    revenue: number
    collected: number
    balance_at_the_end: number
    statuses: ApiStatusesType // сумма по каждому статусу
  }
}

export const convertResultEncashments = (res: ApiResultEncashments): ReportEncashmentsData => {
  const { date, rows, summary } = res

  const rowsData = rows.map((row) => {
    const { summary, encashments } = row
    const res: EncashmentsRowItemType = {
      encashmentsSummary: converRowSummary(summary),
      encashmentsDetails: converRowEncashments(encashments),
    }
    return res
  })

  const {
    balance_at_the_beginning: balanceAtTheBeginning,
    revenue,
    collected,
    balance_at_the_end: balanceAtTheEnd,
    statuses,
  } = summary

  return {
    date: new SimpleDate(date, dateFormat),
    rows: rowsData,
    totalSummary: {
      balanceAtTheBeginning: toFixedValue(balanceAtTheBeginning),
      revenue: toFixedValue(revenue),
      collected: toFixedValue(collected),
      balanceAtTheEnd: toFixedValue(balanceAtTheEnd),
      statuses: convertStatuses(statuses),
    },
  }
}
